var _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppSwitcher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.021,
    y: 3,
    width: 8,
    height: 8,
    rx: 1,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.021,
    y: 3,
    width: 8,
    height: 8,
    rx: 1,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.021,
    y: 13,
    width: 8,
    height: 8,
    rx: 1,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.021 14C11.021 13.4477 10.5733 13 10.021 13H4.021C3.46871 13 3.021 13.4477 3.021 14V20C3.021 20.5523 3.46871 21 4.021 21H10.021C10.5733 21 11.021 20.5523 11.021 20V14ZM9.42099 15.6C9.42099 15.0478 8.97328 14.6 8.42099 14.6H5.62099C5.06871 14.6 4.62099 15.0478 4.62099 15.6V18.4C4.62099 18.9523 5.06871 19.4 5.62099 19.4H8.42099C8.97328 19.4 9.42099 18.9523 9.42099 18.4V15.6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppSwitcher);
export default __webpack_public_path__ + "static/media/appSwitcher.5a180c8efc0cb4f942f996b56e3ef6b7.svg";
export { ForwardRef as ReactComponent };